import { TRootState } from "store";
import { IUserState } from "./user.types";

export const getUserSelector = (state: TRootState): IUserState => state.user;
